import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { GameLessonProgress } from "models/LessonProgress";
import { StyledPaper, StyledCircleIcon } from "components/views/myTrainings/LessonProgressNodes/LessonProgressNodes.styles";

export const GameLessonProgressSummary = (props: {
    lp: GameLessonProgress;
    isCompleted: boolean;
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const events = props.lp.lessonVersion.events ?? [];

    if (events.length === 0) {
        return (
            <StyledPaper sx={{ padding: theme.spacing(2) }}>
                <Typography fontWeight="500" textAlign="center">
                    {t("myTrainings.gameLesson.noEventsConfigured")}
                </Typography>
            </StyledPaper>
        );
    }

    return (
        <Stack spacing={theme.spacing(2)}>
            <Typography variant="subtitle2" color="text.secondary">
                {t("myTrainings.gameLesson.scoringEvents")}
            </Typography>
            {events.map((ev, index) => (
                <StyledPaper key={`${ev.eventKey}-${index}`}>
                    <Stack direction="row" spacing={2} width="100%">
                        <Stack
                            direction="row"
                            width="20%"
                            spacing={theme.spacing(2)}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Stack direction="row" width="30%" justifyContent="center">
                                <StyledCircleIcon />
                            </Stack>
                            <Stack
                                display="flex"
                                flexDirection="column"
                                width="70%"
                                justifyContent="flex-start"
                                alignContent="flex-start"
                            >
                                <Typography fontWeight="500">{ev.eventKey}</Typography>
                            </Stack>
                        </Stack>
                        <Divider orientation="vertical" flexItem />
                        <Stack direction="column" width="80%" justifyContent="center">
                            <Typography fontWeight="700">
                                {t("myTrainings.gameLesson.pointsLabel", { points: ev.points })}
                            </Typography>
                        </Stack>
                    </Stack>
                </StyledPaper>
            ))}
            {!props.isCompleted && (
                <StyledPaper sx={{ paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) }}>
                    <Typography fontWeight="700" textAlign="center">
                        {t("myTrainings.historicalProgress.notFinished")}
                    </Typography>
                </StyledPaper>
            )}
        </Stack>
    );
};
